import script from "./AltarScenes.vue?vue&type=script&setup=true&lang=js"
export * from "./AltarScenes.vue?vue&type=script&setup=true&lang=js"

import "./AltarScenes.vue?vue&type=style&index=0&id=adb5222a&lang=css"

const __exports__ = script;

export default __exports__